import React, { useState } from 'react';
import './DemandForecast.css';
import { ReactComponent as UploadIcon } from '../../../icons/upload.svg';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { uploadFile } from '../../../store/state/DemandForecast';

export default function DemandForecast() {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [title, setTitle] = useState<string>('');

  const { loading, successMessage, errorMessage } = useSelector((state: RootState) => state.demandForecast);

  const validFileTypes = ['application/vnd.ms-excel', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

  // Handle file selection
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file && validFileTypes.includes(file.type)) {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
      alert('Unsupported file format. Only CSV or Excel files are allowed.');
    }
  };

  // Handle file upload
  const handleUpload = () => {
    if (selectedFile) {
      dispatch(uploadFile({ file: selectedFile, title }));
    } else {
      alert('Please select a valid file.');
    }
  };

  return (
    <>
      <div className="header">
        <h1>Demand Forecast</h1>
      </div>
      <div className="demand-container">
      <div className="file-input-wrapper">
        <UploadIcon width={40} height={40} />
        <input
          type="file"
          accept=".csv, .xls, .xlsx"
          id="file-upload"
          onChange={handleFileChange}
          style={{ display: 'none' }}  // Hide the default file input
        />
        <label htmlFor="file-upload" className="choose-file-label">
          {selectedFile ? selectedFile.name : 'Choose File'}
        </label>
      </div>

      {selectedFile && <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Enter file title"
        className="file-title-input"
      />}
      
      <button onClick={handleUpload} disabled={!selectedFile || loading}>
        {loading ? 'Uploading...' : 'Upload File'}
      </button>

      {/* Display error or success message */}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      {successMessage && <div className="success-message">{successMessage}</div>}
    </div>

      {/* Display error or success message */}
    </>
  );
}
